// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"AddMenuSupplier_pageHolder__3ruqO","imageHolder":"AddMenuSupplier_imageHolder__1cqbt","PageHolder":"AddMenuSupplier_PageHolder__1Voqp"};